import { toast } from "react-toastify"
import 'react-toastify/dist/ReactToastify.css';


export function toastMsg(type,msg){
    toast[type](msg,{autoClose:1500} ,);
}

